import { useHistory, useRouteMatch } from 'react-router';

import { COMPANY, DISCIPLINE, EMPLOYMENT_TYPE, SERPS_PARAMS } from '../../constants';
import { SerpsCategoryName } from '../../types';
import {
  companySlugToLocalizedString,
  disciplineSlugToId,
  employmentTypeSlugToId,
} from '../../utils/static-data-utils';

type RouteParams = {
  categoryValue?: string;
  subcategoryValue?: string;
};

export type SerpsRouteInfo = {
  url: string;
  category: SerpsCategoryName;
  categoryValue: string;
  subcategory?: SerpsCategoryName;
  subcategoryValue?: string;
};

export function useSerpsMatch(): SerpsRouteInfo | null {
  const { url, path, params } = useRouteMatch<RouteParams>();
  const history = useHistory();

  if (!(path in SERPS_PARAMS)) return null;

  const { category, subcategory } = SERPS_PARAMS[path];
  const { categoryValue, subcategoryValue } = params;

  const isUnknownDisciplineCategory = category === DISCIPLINE && !disciplineSlugToId(categoryValue as string);
  const isUnknownEmploymentCategory = category === EMPLOYMENT_TYPE && !employmentTypeSlugToId(categoryValue as string);
  const isUnknownCompany = category === COMPANY && !companySlugToLocalizedString(categoryValue as string);
  let shouldReplace = isUnknownDisciplineCategory || isUnknownEmploymentCategory || isUnknownCompany;

  if (subcategory) {
    // Safe cast, if there's subcategory, subcategoryValue will also exists as the pattern
    // will only pass if both values exist
    const isUnknownDisciplineSubcategory =
      subcategory === DISCIPLINE && !disciplineSlugToId(subcategoryValue as string);
    const isUnknownEmploymentSubcategory =
      subcategory === EMPLOYMENT_TYPE && !employmentTypeSlugToId(subcategoryValue as string);
    shouldReplace = shouldReplace || isUnknownDisciplineSubcategory || isUnknownEmploymentSubcategory;
  }

  if (shouldReplace) {
    history.replace('/');
    return null;
  }

  return {
    url,
    category,
    categoryValue,
    ...(subcategory && { subcategory }),
    ...(subcategoryValue && { subcategoryValue }),
  };
}
